<template>
  <span class="svg-icon-hover-box">
    <svg-icon class-name="icon-class icon-class-default" :icon-class="svgIconClass" />
    <svg-icon class-name="icon-class icon-class-hover" :icon-class="svgIconClassHover" />
  </span>
</template>

<script>
export default {
  props: {
    svgIconClass: {
      type: String,
      default: ''
    },
    svgIconClassHover: {
      type: String,
      default: ''
    },
  },
}
</script>

<style lang="scss" scoped>
.svg-icon-hover-box {

  .icon-class-default {
    display: inline-block;
  }
  .icon-class-hover {
    display: none;
  }

  &:hover {
    .icon-class-default {
    display: none;
  }
    .icon-class-hover {
      display: inline-block;
    }
  }
}
</style>
